"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dropbox;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var defaultState = _immutable.default.Map({
  status: _Constants.RequestStatus.UNINITIALIZED,
  file: null
});

function Dropbox() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      file = action.file;

  switch (type) {
    case _ActionTypes.DOWNLOAD_FROM_DROPBOX_ATTEMPTED:
      return _immutable.default.Map({
        status: _Constants.RequestStatus.PENDING,
        file: file
      });

    case _ActionTypes.DOWNLOAD_FROM_DROPBOX_SUCCEEDED:
      return _immutable.default.Map({
        status: _Constants.RequestStatus.SUCCEEDED,
        file: file
      });

    case _ActionTypes.DOWNLOAD_FROM_DROPBOX_FAILED:
      return _immutable.default.Map({
        status: _Constants.RequestStatus.FAILED,
        file: file
      });

    default:
      return state;
  }
}

module.exports = exports.default;